// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1gua2","messages":"Chat_messages__EpNd1","dateDivider":"Chat_dateDivider__1oAA5"};